import axios, { AxiosResponse } from 'axios';

/**
 * Создание Опроса
 * @param data
 */
export const createQuestionnaire = (data: any): Promise<AxiosResponse> => {
    return axios.post('/services/isnaportal/open-api/admin/questionnaire', data, {
            params: {
                sort: 'questionnaireWeight'
            }
        }
    );
};

/**
 * Получить Опрос по ID
 * @param id
 */
export const getQuestionnaireById = (id: number): Promise<AxiosResponse> => {
    return axios.get('/services/isnaportal/open-api/admin/questionnaire/' + id);
};

/**
 * Получить список Опросов
 * @param params
 */
export const getQuestionnaireList = (params: any): Promise<AxiosResponse> => {
    return axios.get('/services/isnaportal/open-api/admin/questionnaire', {
        params: {
            ...params,
            sort: 'questionnaireWeight'
        }
    });
};

/**
 * Обновить Опрос
 * @param id
 * @param data
 */
export const updateQuestionnaire = (id: number, data: any): Promise<AxiosResponse> => {
    return axios.put('/services/isnaportal/open-api/admin/questionnaire/' + id, data);
};

/**
 * Удалить Опрос по ID
 * @param id
 */
export const deleteQuestionnaireById = (id: number): Promise<AxiosResponse> => {
    return axios.delete('/services/isnaportal/open-api/admin/questionnaire/' + id);
};

/**
 * Поиск по Опросам
 * @param searchParams
 */
export const searchQuestionnaire = (searchParams: any): Promise<AxiosResponse> => {
    return axios.post('/services/isnaportal/open-api/admin/questionnaire/filter', searchParams, {
        params: {
            sort: 'questionnaire_weight'
        }
    });
};





/**
 * Создание Вопроса
 * @param data
 */
export const createQuestion = (data: any): Promise<AxiosResponse> => {
    return axios.post('/services/isnaportal/api/admin/questionnaire/question', data);
};

/**
 * Получить Вопрос по ID
 * @param id
 */
export const getQuestionById = (id: number): Promise<AxiosResponse> => {
    return axios.get('/services/isnaportal/open-api/admin/questionnaire/question/' + id);
};

/**
 * Получить список Вопросов
 */
export const getQuestionList = (): Promise<AxiosResponse> => {
    return axios.get('/services/isnaportal/open-api/admin/questionnaire/question');
};

/**
 * Получить список Вопросов по ID Опроса
 * @param questionnaireId
 * @param params
 */
export const getQuestionsByQuestionnaireId = (questionnaireId: number, params?: any): Promise<AxiosResponse> => {
    return axios.get('/services/isnaportal/open-api/admin/questionnaire/question/questionnaire/' + questionnaireId, {
        params: {
            ...params,
            sort: 'questionWeight'
        }
    });
};

/**
 * Обновить Вопрос
 * @param id
 * @param data
 */
export const updateQuestion = (id: number, data: any): Promise<AxiosResponse> => {
    return axios.put('/services/isnaportal/api/admin/questionnaire/question/' + id, data);
};

/**
 * Удалить Вопрос по ID
 * @param id
 */
export const deleteQuestionById = (id: number): Promise<AxiosResponse> => {
    return axios.delete('/services/isnaportal/open-api/admin/questionnaire/question/' + id);
};

/**
 * Поиск по Вопросам
 * @param searchParams
 */
export const searchQuestion = (searchParams: any): Promise<AxiosResponse> => {
    return axios.post('/services/isnaportal/open-api/admin/questionnaire/question/filter', searchParams, {
        params: {
            sort: 'question_weight'
        }
    });
};

/**
 * Добавить Вопрос к Ответу
 * @param answerId
 * @param questionId
 */
export const addQuestionToAnswer = (answerId: number, questionId: number): Promise<AxiosResponse> => {
    return axios.post(`/services/isnaportal/open-api/admin/questionnaire/answer/${answerId}/${questionId}`);
};


/**
 * Отвязать Вопрос от Ответа
 * @param answerId
 */
export const unsetQuestionFromAnswer = (answerId: number): Promise<AxiosResponse> => {
    return axios.post(`/services/isnaportal/open-api/admin/questionnaire/answer/unset-next-question/${answerId}`);
};





/**
 * Создание Ответа
 * @param data
 */
export const createAnswer = (data: any): Promise<AxiosResponse> => {
    return axios.post('/services/isnaportal/open-api/admin/questionnaire/answer', data);
};

/**
 * Получить Ответ по ID
 * @param id
 */
export const getAnswerById = (id: number): Promise<AxiosResponse> => {
    return axios.get('/services/isnaportal/open-api/admin/questionnaire/answer/' + id);
};

/**
 * Получить список Ответов
 * @param questionnaireId
 */
export const getAnswerList = (questionnaireId?: number): Promise<AxiosResponse> => {
    return axios.get('/services/isnaportal/open-api/admin/questionnaire/answer', {
        params: {
            questionnaireId: questionnaireId
        }
    });
};

/**
 * Получить список Ответов по ID Вопроса
 * @param questionId
 */
export const getAnswersByQuestionId = (questionId: number): Promise<AxiosResponse> => {
    return axios.get(`/services/isnaportal/open-api/admin/questionnaire/answer/question/${questionId}/all`);
};

/**
 * Обновить Ответ
 */
export const updateAnswer = (id: number, data: any): Promise<AxiosResponse> => {
    return axios.put('/services/isnaportal/open-api/admin/questionnaire/answer/' + id, data);
};

/**
 * Удалить Ответ по ID
 * @param id
 */
export const deleteAnswerById = (id: number): Promise<AxiosResponse> => {
    return axios.delete('/services/isnaportal/open-api/admin/questionnaire/answer/' + id);
};

/**
 * Поиск по Ответам
 * @param searchParams
 */
export const searchAnswer = (searchParams: any): Promise<AxiosResponse> => {
    return axios.post('/services/isnaportal/open-api/admin/questionnaire/answer/filter', searchParams);
};





/**
 * Создание Результата
 * @param data
 */
export const createResult = (data: any): Promise<AxiosResponse> => {
    return axios.post('/services/isnaportal/api/admin/questionnaire/result', data);
};

/**
 * Получить Результат по ID
 * @param id
 */
export const getResultById = (id: number): Promise<AxiosResponse> => {
    return axios.get('/services/isnaportal/open-api/admin/questionnaire/result/' + id);
};

/**
 * Получить список Результатов
 */
export const getResultList = (): Promise<AxiosResponse> => {
    return axios.get('/services/isnaportal/open-api/admin/questionnaire/result');
};

/**
 * Получить список Результатов по ID Ответа
 * @param answerId
 */
export const getResultsByAnswerId = (answerId: number): Promise<AxiosResponse> => {
    return axios.get('/services/isnaportal/open-api/admin/questionnaire/result', {
        params: {
            answerId
        }
    });
};

/**
 * Обновить Результат
 * @param id
 * @param data
 */
export const updateResult = (id: number, data: any): Promise<AxiosResponse> => {
    return axios.put('/services/isnaportal/open-api/admin/questionnaire/result/' + id, data);
};

/**
 * Добавить Результат к Ответу
 * @param resultId
 * @param answerId
 */
export const addResultToAnswer = (resultId: number, answerId: number): Promise<AxiosResponse> => {
    return axios.post(`/services/isnaportal/open-api/admin/questionnaire/result/${resultId}/${answerId}`);
};

/**
 * Удалить Результат по ID
 * @param id
 */
export const deleteResultById = (id: number): Promise<AxiosResponse> => {
    return axios.delete('/services/isnaportal/open-api/admin/questionnaire/result/' + id);
};

/**
 * Поиск по Результатам
 * @param searchParams
 */
export const searchResult = (searchParams: any): Promise<AxiosResponse> => {
    return axios.post('/services/isnaportal/open-api/admin/questionnaire/result/filter', searchParams);
};




/**
 * Создание Типа Результата
 * @param data
 */
export const createResultType = (data: any): Promise<AxiosResponse> => {
    return axios.post('/services/isnaportal/open-api/admin/questionnaire/result-type', data);
};

/**
 * Получить Тип Результата по ID
 * @param id
 */
export const getResultTypeById = (id: number): Promise<AxiosResponse> => {
    return axios.get('/services/isnaportal/open-api/admin/questionnaire/result-type/' + id);
};

/**
 * Получить список Типов Результата
 */
export const getResultTypeList = (): Promise<AxiosResponse> => {
    return axios.get('/services/isnaportal/open-api/admin/questionnaire/result-type');
};

/**
 * Обновить Тип Результата
 * @param id
 * @param data
 */
export const updateResultType = (id: number, data: any): Promise<AxiosResponse> => {
    return axios.put('/services/isnaportal/open-api/admin/questionnaire/result-type/' + id, data);
};

/**
 * Удалить Тип Результата по ID
 * @param id
 */
export const deleteResultTypeById = (id: number): Promise<AxiosResponse> => {
    return axios.delete('/services/isnaportal/open-api/admin/questionnaire/result-type/' + id);
};

/**
 * Поиск по Типам Результата
 * @param searchParams
 */
export const searchResultType = (searchParams: any): Promise<AxiosResponse> => {
    return axios.post('/services/isnaportal/open-api/admin/questionnaire/result-type/filter', searchParams);
};
